import * as React from "react"

const SvgMegaMenuButton2Background = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={301}
    height={57}
    viewBox="0 0 301 57"
    {...props}
  >
    <defs>
      <clipPath id="a">
        <path
          data-name="Rectangle 6"
          transform="translate(1574 106)"
          d="M0 0h301v57H0z"
        />
      </clipPath>
    </defs>
    <path data-name="Rectangle 7" fill="#3e3e3e" d="M0 0h301v57H0z" />
    <g
      data-name="Mask Group 1"
      clipPath="url(#a)"
      transform="translate(-1574 -106)"
    >
      <path
        data-name="Path 7"
        d="M1833.219 104.047s-107.692 48.521-237.87 57.988 295.858 7.692 295.858 7.692l-8.876-72.781-43.2-2.367Z"
        fill="#353535"
      />
    </g>
  </svg>
)

export default SvgMegaMenuButton2Background
